import axios from "@/plugins/axios";

let url = "/api/console/shop/dashboard";

export default {
    getDashboard(data){
        return axios.get(`${url}/${data.code}`).then(result => result.data);
    }
}
